module.exports = __webpack_public_path__ + "img/bank-23-sbi.99600ebf.svg";